module.exports = __webpack_public_path__ + "img/PocketMoni.627288b1.svg";